import type { DocMigration } from "../docMigration";

// eslint-disable-next-line @typescript-eslint/naming-convention
const migration_0_0_200: DocMigration = {
  maxSchemaVersion: "0.0.200",
  description: "Enabling the annotation catalog origin filter",
  apply(json: any) {
    const { viewerFilter } = json;
    if (viewerFilter) {
      viewerFilter["annotationCatalogOrigin"] = true;
    }

    return json;
  },
};

export default migration_0_0_200;
